/* eslint max-len: ["error", { "ignoreRegExpLiterals": true }] */
(function() {
  'use strict';

  var providers = [{
        name: 'youtube',
        regexp: /<div>(?:(https?:\/\/|\/\/)?(?:www\.)?(?:youtu(\.?be)?(\.com\/)?)(watch|\/|embed|v)?(\?v=|\/))([^"&?\/ ]{11})<\/div>/g,
        aregexp: /<a\s+(?:[^>]*)href=\"((?:https:\/\/|http:\/\/|http:\/\/\w{0,3}.|https:\/\/\w{0,3}.)youtube+\.\w{2,3}\/watch\?v=([\w-]{11}))".*?>(?:.*?)<\/a>/g,
        amatchexp: /<a\s+(?:[^>]*)href=\"((?:https:\/\/|http:\/\/|http:\/\/\w{0,3}.|https:\/\/\w{0,3}.)youtube+\.\w{2,3}\/watch\?v=([\w-]{11}))".*?>(?:.*?)<\/a>/,
        matchexp: /<div>(?:(https?:\/\/|\/\/)?(?:www\.)?(?:youtu(\.?be)?(\.com\/)?)(watch|\/|embed|v)?(\?v=|\/))([^"&?\/ ]{11})<\/div>/,
        embed: '//www.youtube.com/embed/'
      }, {
        name: 'vimeo',
        regexp: /<div>(?:(https?:)?\/\/vimeo.com\/(?:channels\/|groups\/[^\/]*\/videos\/|album\/\d+\/video\/|video\/|)?)([\w.-]{9,10})(\/[\w.-]{9,10})?<\/div>/g,
        aregexp: /<a\s+(?:[^>]*)href=\"(http|https?:\/\/?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/[^\/]*\/videos\/|)([\w.-]{9,10})(\/[\w.-]{9,10})?)".*?>(?:.*?)<\/a>/g,
        amatchexp: /<a\s+(?:[^>]*)href=\"(http|https?:\/\/?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/[^\/]*\/videos\/|)([\w.-]{9,10})(\/[\w.-]{9,10})?)".*?>(?:.*?)<\/a>/,
        matchexp: /<div>(?:(https?:)?\/\/vimeo.com\/(?:channels\/|groups\/[^\/]*\/videos\/|album\/\d+\/video\/|video\/|)?)([\w.-]{9,10})(\/[\w.-]{9,10})?<\/div>/,
        embed: '//player.vimeo.com/video/'
      }],
      wrapWithIframe = function(url, provider) {
        var match = url.match(provider.matchexp),
            vid = match[match.length - 1];

        return (
          '<div class="embed-responsive embed-responsive-16by9">' +
          '<iframe class="embed-responsive-item" src="' +
            provider.embed + vid +
          '"></iframe></div>'
        );
      },
      removeStartingSlash = function(str) {
        // If we don't have to support IE11, we can use str.startsWith('/')
        return _.startsWith(str, '/') ? str.slice(1) : str;
      },
      getVimeoUrl = function(vid) {
        if (_.isArray(vid)) {
          // When the Vimeo video has a format like vimeo.com/{id1}/{id2}
          // the embed code is different: player.vimeo.com/video/{id1}?h={id2}
          return vid[0] + '?h=' + removeStartingSlash(vid[1]);
        }
        // Classic videos follow the format player.vimeo.com/{id}
        return vid;
      },
      wrapIDWithIframe = function(vid, provider) {
        return (
          '<div class="embed-responsive embed-responsive-16by9">' +
          '<iframe class="embed-responsive-item" src="' +
            provider.embed + vid +
          '"></iframe></div>'
        );
      },
      replaceUrl = function(content, provider) {
        if (content.search(provider.aregexp) !== -1) {
          content = content.replace(provider.aregexp, function(link) {
            var match = link.match(provider.amatchexp);
            // When the video is a Vimeo of the new format vime.com/{id1}/{id2}
            var url = (provider.name === 'vimeo' && match[3])
              ? getVimeoUrl([match[2], match[3]])
              : match[2];
            return wrapIDWithIframe(url, provider);
          });
        }

        if (content.search(provider.regexp) !== -1) {
          content = content.replace(
            provider.regexp,
            function(url) {
              return wrapWithIframe(url, provider);
            }
          );
        }

        return content;
      };

  function filter($sce) {
    return function(content) {
      var parse = function(provider) {
        content = replaceUrl(content, provider);
      };

      if (content) {
        _.forEach(providers, parse);
      }

      return $sce.trustAsHtml(content);
    };
  }

  filter.$inject = ['$sce'];

  angular.module('blocks.utils')
    .filter('videoUrlToIframe', filter);
})();
